export default {
  "Daily Snow Cover": "snowcover_",
  "Snow Cover Fraction": "nhp_snf_",
  Forecast: "nhp_smf_",
  Actual: "nhp_sma_",
};
